import util from '@/utils'

export default {
  methods: {
    tdFormatterForDate (row, column, cellValue) {
      return util.dateFormat(cellValue)
    }
  }
}
